__turbopack_context__.v({
  "fixedBgContent": "Bo8Kea_fixedBgContent",
  "fixedBgImageWrap": "Bo8Kea_fixedBgImageWrap",
  "fixedBgLayer": "Bo8Kea_fixedBgLayer",
  "fixedBgOverlay": "Bo8Kea_fixedBgOverlay",
  "fixedBgSectionRoot": "Bo8Kea_fixedBgSectionRoot",
  "fixedBgTextStage": "Bo8Kea_fixedBgTextStage",
  "fixedBgVhSpacer": "Bo8Kea_fixedBgVhSpacer",
  "fixedBgViewportContent": "Bo8Kea_fixedBgViewportContent",
});
